import React from "react";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';
function Timing() {
  const { t } = useTranslation();
  return (
    <div>
     <div className="row banner" style={{ display:'flex',alignItems:'center',justifyContent:'center',background:'orange', backgroundSize: 'cover', backgroundPosition: 'center',height:'400px' }}>
      <img src="./images/maruthi.png" alt="image" style={{width:'20%'}} />
      </div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row">
            <div className="col-md-12" style={{background:'#ffffffd2',padding:'50px',border:'1px solid silver'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">{t("p-darsantime")}</p> </center>                                         
                    </div>
                </div>
                <p className="darsan-time"></p>
                <p className="darsan-time">{t("time-1")}</p>
                <p className="darsan-time">{t("time-2")}</p>
                <p className="darsan-time">{t("time-3")}</p>
                <p className="darsan-time">{t("time-4")}</p>
            
           </div> 
            {/* <div class="col-md-5" style={{backgroundImage:'url(./images/makreri.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}>
                
            </div> */}
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;